import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip'
import {setTradeAddress} from '../../../../actions/ui/marketplace';
import {Decimal} from 'decimal.js';

let temp = [
  {label: "Available", amount: 0},
  {label: "Collateralized", amount: 0},
  {label: "Spending", amount: 0},
  {label: "Unlockable", amount: 0}
]

class Balance extends Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(){
    super();
  }
  shouldComponentUpdate(nextProps,nextState){
    let update = false;
    if(nextProps.address != this.props.address) update = true
    // if(nextProps.data != this.props.data) return true
    if(nextProps.nrgPrice != this.props.nrgPrice) update = true;
    if(JSON.stringify(nextProps.others) != JSON.stringify(this.props.others)) update = true;
    for(let i = 0; i < nextProps.data.length; i++){
      if(nextProps.data[i].amount != this.props.data[i].amount) update = true;
    }
    return update;
  }
  componentDidUpdate(props){
    this.updateChart();
  }
  updateChart(){
    this.chart.data = this.props.data
  }
  returnData(){
    let colors = [
      am4core.color("#2a79ff"),
      am4core.color("#2a79ff").lighten(0.3),
      am4core.color("#2a79ff").lighten(0.5),
      am4core.color("#2a79ff").lighten(0.7),
    ]
    // <span style={{color:'grey'}}>${Math.max(0,amountReal)}</span>

    let map = this.props.data ? this.props.data : temp;
    return map.map(({label,amountReal},i)=>{
      return <div key={i} className='col s12' style={{padding:0}}>
        <div className='nrgdata'>
          <div className='nrg_box' style={{background:colors[i].hex}}></div>
          <span style={{opacity:0.7}}>{label}: </span> <br/>
          <span>{Math.max(0,amountReal)}</span> <br/>
        </div>
      </div>
    })
  }
  initiateChart(){
    let chart = am4core.create("nrgdiv", am4charts.PieChart);

    // Add and configure Series
    chart.innerRadius = am4core.percent(50);
    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = 'amount';
    pieSeries.dataFields.category = 'label';
    pieSeries.dataFields.amountReal = 'amountReal';
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;
    pieSeries.slices.template.tooltipText = "";
    var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    this.chart = chart;

    pieSeries.colors.list = [
      am4core.color("#2a79ff"),
      am4core.color("#2a79ff").lighten(0.3),
      am4core.color("#2a79ff").lighten(0.5),
      am4core.color("#2a79ff").lighten(0.7),
    ];

    this.updateChart()
  }
  setAddress(addr){
    this.props.setTradeAddress('nrg',addr,()=>{})
  }
  componentDidMount(){
    let _this = this;
    this.initiateChart();
  }
  render() {
    // <h5 className='center white-text' style={{marginBottom:0,padding:0}}>NRG</h5>
    let addresses = this.props.others && this.props.others.map((a,i) => {
      let opacity = this.props.address == a ? 1: 0.5;
      return (
        <p key={i} onClick={this.setAddress.bind(this,a)} style={{padding:'2px',opacity,fontSize:'10px', lineHeight:'25px', cursor:'pointer'}}>
          {a}
        </p>
      )
    })
    return (
      <div className='col s12' style={{padding:0}}>
        <p className='nrgStats'>{this.props.nrgPrice && `1 OL = ${this.props.nrgPrice}`}</p>
        <div className='col s12'>
          <div style={{}}>
            <p style={{color:'white',fontSize:'10px',paddingTop:'10px',paddingLeft:'10px',cursor:'pointer'}}
              ref={(c) => { this.ref = c; }}
              data-tip={`hello`} data-for={'nrg_tooltip'}
              onMouseOver={() => { ReactTooltip.show(this.ref); }}
              onMouseLeave={() => { ReactTooltip.hide(this.ref); }}
              >
              {this.props.address}
            </p>
          </div>
        </div>
        <div className='col s6 center' style={{padding:0}}>
          <div className='nrgdiv' id="nrgdiv" style={{maxWidth:'100%',height:'190px',pointerEvents:'none'}}> </div>
        </div>
        <div id='nrgDataItems' className='col s6' style={{marginTop:'35px'}}>
          {this.returnData.bind(this)()}
        </div>
        <ReactTooltip id={'nrg_tooltip'} place="top" type="dark" effect="solid" className='extraClass' delayHide={100}>
          <p>Choose OL Address: </p>
          <hr/>
          {addresses}
        </ReactTooltip>
      </div>
    );
  }
}



function mapStateToProps(state,props) {
  let address = state.passport.tradeAddresses.nrg;
  let others = Object.keys(state.passport.nrg)

  let bal = {
    nrg: state.passport.nrg[address] ? state.passport.nrg[address] : 0,
    nrg_collateralized: state.passport.nrg_collateralized[address] ? state.passport.nrg_collateralized[address] : 0,
    unlockable: state.passport.unlockable[address] ? state.passport.unlockable[address] : 0,
    spending: 0
  }

  let available = bal.spending > 0 ? Math.max(0,new Decimal(bal.nrg).sub(new Decimal(bal.spending)).toNumber()) : Math.max(1, bal.nrg);
  if(bal.spending == 0 && bal.nrg_collateralized) available = Math.max(1,bal.nrg)

  let data = [
    {
      label: "Available",
      amount: available,
      amountReal: new Decimal(bal.nrg).sub(new Decimal(bal.spending)).toNumber()
    },
    {
      label: "Collateralized",
      amount: Math.max(0,bal.nrg_collateralized),
      amountReal: bal.nrg_collateralized
    },
    {
      label: "Unlockable",
      amount: Math.max(0,bal.unlockable),
      amountReal: bal.unlockable
    }
  ];

  let nrgPrice =
  new Decimal(state.price.btc).div(new Decimal(state.orderbook.stats[`auction`][`BTC/NRG`].lastPrice.price));

  if(nrgPrice.eq(new Decimal(Infinity))) nrgPrice = '';
  else nrgPrice = `\$${nrgPrice.toFixed(2)}`;

  return {
    nrgPrice,
    others,
    address,
    data
  };
}

export default connect(mapStateToProps,{
setTradeAddress
})(Balance);
